export enum PermissionStatus {
  PROMPT = 'prompt',
  GRANTED = 'granted',
  DENIED = 'denied',
  REQUESTING = 'requesting',
  ERROR = 'error',
}

export enum NotificationImportance {
  MIN = 1,
  LOW = 2,
  DEFAULT = 3,
  HIGH = 4,
  MAX = 5,
}

export enum NotificationVisibility {
  SECRET = -1,
  PRIVATE = 0,
  PUBLIC = 1,
}

export enum NotificationChannelId {
  GENERAL = 'general',
  CALENDAR = 'calendar',
  MESSAGES = 'messages',
  ALERTS = 'alerts',
}


export interface INotificationChannel {
  id: NotificationChannelId
  name: string
  description?: string
  importance?: NotificationImportance
  visibility?: NotificationVisibility
  sound?: string
  vibration?: boolean
  lights?: boolean
  lightColor?: string
}
